import m from 'mithril'
import moment from 'moment'
import BaseModel from './_base'

let _data = []

const constraints = {

}

var app = {}
app.xhrConfig = function (xhr) {
    xhr.setRequestHeader("Content-Type", "application/json")
}

  
class Tube extends BaseModel {

    constructor(args) {
        super(constraints)
        args = (args) ? args : {};
        this.id = args.id || 0;
        this.serial = args.serial || "";
        this.area = args.area || "";
        this.city = args.city || "";
        this.category = args.category || "";
        this.voter1 = args.voter1 || "";
        this.voter2 = args.voter2 || "";
        this.voter3 = args.voter3 || "";
        this.voter4 = args.voter4 || "";
        this.voter5 = args.voter5 || "";
        this.void = args.void || "";
        this.contact = args.contact || "";
        this.phone = args.phone || "";
        this.updated_at = moment(args.updated_at).format('Y-M-D') || moment().format('Y-M-D');
        this.created_at = moment(args.created_at).format('Y-M-D') || moment().format('Y-M-D');
    }

    static get data() {
        return _data;
    }

    static fetch() {
        Tube.loading = true
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/tube`,            
        }).then((response) => {            
            Tube.loading = false
            return response
        })
    }

    static fetchPhone(phone) {
        Tube.loading = true
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/tubeByPhone/${phone}`,
        }).then((response) => {
            Tube.loading = false
            return response
        })
    }

    static fetch_record() {
        Tube.loading = true
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/tube_fetchRecord`,
        }).then((response) => {
            Tube.loading = false
            return response
        })
    }

    save() {
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/api/tube`,
            body: this,
        })
    }

    static load(serial) {
        Tube.loading = true

        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/tube/${serial}`,
        }).then((response) => {
            Tube.loading = false

            return response
        })
    }

    static delete(id) {
        return m.request({
            method: 'DELETE',
            url: `${window.BASE_URL}/api/tube/${id}`,
        })
    }    
}

export default Tube